import React from "react"
import Heading from "./Heading"
import { Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"

export default function DualInfoBlock({ heading, photo, img2 }) {
  return (
    <BackgroundImage className="my-4 section py-4" fluid={img2}>
      <div className="container">
        <Heading title={heading} />
        <div className="row">
          <div className="col-12 col-xs-12 col-sm-12 col-md-10 col-lg-8 mx-auto">
            <p className=" lead text-white mb-5 text-justify">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus
              at deleniti vitae, sunt praesentium in, totam est ipsam eum
              temporibus vero nihil. Voluptates nesciunt quam earum. Accusamus
              perspiciatis expedita, dicta, cupiditate, vitae laborum corrupti
              ex sapiente nesciunt officia tempora quae magnam modi in. Cumque
              soluta illum voluptates sequi atque amet. Lorem ipsum dolor sit
              amet consectetur adipisicing elit. Incidunt fuga eum perferendis
              soluta mollitia dolore sint inventore! Itaque culpa veritatis
              quidem similique omnis eum necessitatibus cupiditate minima eaque
              labore voluptates in eos vero quod perspiciatis modi id quas,
              quae, tempora, ullam quisquam. Nemo laborum fuga quibusdam
              voluptas. Iure in amet error. Tenetur sequi corrupti odio,
              provident nemo neque perspiciatis a velit ipsam repudiandae
              doloremque maiores dicta voluptatibus saepe repellendus debitis
              labore id ipsum ducimus sunt facilis quasi aut vitae. Hic nemo
              voluptatum itaque fugit eveniet provident voluptas velit vero
              molestiae. Nihil quas facilis dolore error repellat asperiores
              architecto sunt animi.
            </p>
          </div>
          <div className="col-11 col-xs-12 col-sm-8 col-md-6 col-lg-4 mx-auto mt-2 mb-3">
            <div className="card bg-dark border-warning">
              <img
                src={photo}
                className="card-img-top text-white"
                alt="image goes here"
              />
              <div className="card-body">
                <h5 className="card-title text-success heading">
                  aashish paliwal
                </h5>
                <p className="card-text text-light text-center">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Suscipit inventore nam est numquam explicabo obcaecati. Lorem
                  ipsum dolor sit amet consectetur adipisicing elit. Laborum,
                  quibusdam.
                </p>
                <Link to="/about">
                  <button className="btn btn-warning btn-block">
                    {heading}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BackgroundImage>
  )
}
